import React from "react";
import styled from "styled-components";
import BadgeButton from "../../ui-library/Buttons/BadgeButton/BadgeButton";

const PageButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  & > div {
    display: flex;
    flex-direction: column;
    flex: 0 0 calc(33% - 10px);
    margin: 0 5px;
    flex-wrap: wrap;

    & > button {
      margin-bottom: 30px;
    }
    @media (max-width: 647px) {
      margin: 0;
      flex-basis: 100%;
    }
  }
`;

const TopPageButtons = ({ buttons }) => {
  return (
    <PageButtonsWrapper data-testid="top-page-buttons">
      {buttons.map((item) => (
        <BadgeButton
          key={item.id}
          id={item.id}
          text={item.text}
          onClick={item.onClick}
        />
      ))}
    </PageButtonsWrapper>
  );
};

export default TopPageButtons;
